import Component from '../core/Component'
import throttle from 'lodash/throttle'
import Scroll from '../services/Scroll'
import EventBus from '../core/EventBus'
import { EVENTS } from '../core/Events'
import withMedia from '../core/withMedia'

export const STATES = {
    STICKY: 'is-sticky'
}

export const EMITS = {
    PROGRESS: 'progress'
}

export class Sticky2 extends Component {
    constructor(element, options = {}) {
        super(element, {
            top: 70,
            ...options
        })

        this.isSticky = false
        this.isAfterResize = true
        this.isDestroyed = false

        this.handleScroll = this.handleScroll
        this.handleResize = throttle(this.handleResize, 200)
    }

    prepare() {
        this.parent = this.element.parentNode
        this.element.style.paddingTop = this.options.top + 'px'

        Scroll.on('resize', this.handleResize)
        Scroll.on('scroll', this.handleScroll)
        EventBus.on(EVENTS.DOM_CHANGE, this.handleResize)

        this.resizeAndRender()
    }

    destroy() {
        Scroll.off('scroll', this.handleScroll)
        Scroll.off('resize', this.handleResize)
        EventBus.off(EVENTS.DOM_CHANGE, this.handleResize)
        this.clear()
        this.element.style.paddingTop = ''
        this.isDestroyed = true
    }

    handleScroll = () => {
        this.render()
    }

    handleResize = () => {
        if (this.isDestroyed) {
            return
        }
        this.resizeAndRender()
    }

    resizeAndRender() {
        this.resize()
        this.isAfterResize = true
        this.render()
        this.isAfterResize = false
    }

    resize() {
        this.clear()
        this.element.offsetWidth

        const scrollTop = Scroll.getScroll().y

        const windowBox = {
            height: window.innerHeight
        }


        const elementBox = this.element.getBoundingClientRect()
        this.elementBox = {
            scrollHeight: elementBox.height,
            height: (windowBox.height > elementBox.height) ? elementBox.height : windowBox.height,
            width: elementBox.width,
            top: scrollTop + elementBox.top,
            left: elementBox.left,
        }

        this.element.style.width = `${this.elementBox.width}px`
        if (this.elementBox.height < this.elementBox.scrollHeight) {
            this.element.style.height = `${this.elementBox.height}px`
        }

        const parentBox = this.parent.getBoundingClientRect()
        this.parentBox = {
            height: parentBox.height,
            width: parentBox.width,
            top: scrollTop + parentBox.top
        }
    }

    render() {
        if (Scroll.isVirtual) {
            this.renderVirtual()
        } else {
            this.renderNative()
        }
    }

    // renderVirtual() {
    //     const offset = Scroll.getScroll().y - this.parentBox.top + this.options.top
    //     const max = this.parentBox.height - this.elementBox.height

    //     if (offset < 0) {
    //         if (this.isSticky) {
    //             this.element.classList.remove(STATES.STICKY)
    //             this.isSticky = false
    //             this.element.style.transform = 'translateY(0px)'
    //         }
    //     } else if (offset > max) {
    //         if (this.isSticky) {
    //             this.element.classList.remove(STATES.STICKY)
    //             this.isSticky = false
    //             this.element.style.transform = `translateY(${max}px)`
    //         }
    //     } else {
    //         if (!this.isSticky) {
    //             this.element.classList.add(STATES.STICKY)
    //             this.isSticky = true
    //         }
    //         this.element.style.transform = `translateY(${offset}px)`
    //     }
    // }

    renderNative() {
        const offset = Scroll.getScroll().y - this.parentBox.top
        const max = Math.max((this.parentBox.height - this.elementBox.height), 0)

        if (max === 0) {
            this.clear()
        }

        if (offset < 0) {
            if (this.isSticky) {
                this.element.classList.remove(STATES.STICKY)
                this.isSticky = false
                this.element.style.left = ''
                this.element.style.top = ''
                this.element.style.transform = ``
                this.element.style.position = ''
            }
        } else if (offset > max) {
            if (this.isSticky || this.isAfterResize) {
                this.element.classList.remove(STATES.STICKY)
                this.isSticky = false
                this.element.style.left = ''
                this.element.style.top = ''
                this.element.style.position = ''
                this.element.style.transform = `translateY(${max}px)`
                this.emit(EMITS.PROGRESS, {
                    progress: Math.min(Math.max(offset / max, 0), 1)
                })
            }
        } else {
            if (!this.isSticky) {
                this.element.classList.add(STATES.STICKY)
                this.isSticky = true
                this.element.style.left = `${this.elementBox.left}px`
                this.element.style.top = `0px`
                this.element.style.transform = ``
                this.element.style.position = 'fixed'
            }

            this.emit(EMITS.PROGRESS, {
                progress: Math.min(Math.max(offset / max, 0), 1)
            })
        }
    }

    clear() {
        this.element.classList.remove(STATES.STICKY)
        this.isSticky = false
        this.element.style.left = ''
        this.element.style.top = ''
        this.element.style.transform = ''
        this.element.style.position = ''
        this.element.style.width = ''
        this.element.style.height = ''
    }
}

export default withMedia(Sticky2)